var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('keep-alive',[(_vm.task.isHomeInvestigate)?_c('home-investigate-detail'):(_vm.task.isMediate)?_c('mediate-task-detail'):(_vm.task.isLawsuit)?_c('lawsuit-task-detail'):(_vm.task.isOtherInvestigate)?_c('other-investigate'):(
				_vm.task.isSimpleVisit ||
					_vm.task.isFirstVisit ||
					_vm.task.isResurvey ||
					_vm.task.isMotion ||
					_vm.task.isNewMotion ||
					_vm.task.isInvestigate
			)?_c('aii-task-detail'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }